<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<div class="print-img">
					<img src="../../assets/print.png" >
					
				</div>
			
					<div class="button-blue fcc" @click="close">
						<img src="../../assets/icon/icon-return.png" >
						<span>确定</span>
					</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-print',
		// props: {
		// 	msg: String
		// },
		data() {
			return {
				//timer:null,
				show:true,
				
			}
		},
	
		
		mounted() {
			
		},
		methods: {
			close(){
				
				this.$emit('close',false)
			}
		},
		beforeDestroy() {
			//clearTimeout(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	.popBox{
		width: 840px;
		height: 905px;
		margin-left: -420px;
	}
	.print-img{
		img{
			display: block;
			max-width: 100%;
			height: auto;
			max-height:700px;
		}
	}
		.inner{
			padding: 30px;
		}
		.button-blue{
			position: absolute;
			right: 30px;
			bottom: 30px;
			width: 200px;
			background: #38BB8B;
			border-radius: 0;
			img{
				height: 40px;
				margin-right: 17px;
			}
		}
</style>
